// extracted by mini-css-extract-plugin
export default {"wrapper":"i4cXX","cookie-wrapper":"o2nrQ","text":"eTyOV","link":"XsjqC","btn":"nzAZn"};